<template>
  <v-sheet class="document-list">
    <template>
      <documents-tree
        :documents="documents"
        :allowDelete="showDelete"
        :allowEdit="showDelete"
      ></documents-tree>
    </template>
    <document-upload v-if="showDelete" />
  </v-sheet>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import DocumentUpload from "@/containers/documents/DocumentUpload"
import DocumentsTree from "@/components/DocumentsTree"
import { DocumentsAPI } from "@/lib/api"
import EventBus from "@/lib/eventBus"
import eventMixin from "@/mixins/eventMixin"
import User from "@/lib/user"

export default {
  mixins: [eventMixin, titleMixin],
  components: {
    DocumentUpload,
    DocumentsTree
  },
  data: function() {
    return {
      title: "System Documents",
      documents: [],
      treeDocuments: [],
      userType: User.getUserType(),
      showDelete: !User.isMember()
    }
  },
  methods: {
    getDocuments: function() {
      DocumentsAPI.list().then(response => {
        this.documents = response
      })
    },
    setLink(el) {
      return el.url
    }
  },
  created() {
    EventBus.$on("DocumentAdded", () => {
      this.getDocuments()
    })

    this.addListener("list:removeItem", itemId => {
      DocumentsAPI.delete(itemId).then(() => {
        this.getDocuments()
      })
    })

    this.addListener("tree:updateItem", item => {
      DocumentsAPI.update(item).then(() => {
        this.getDocuments()
      })
    })
    this.getDocuments()
  }
}
</script>

<style lang="css" scoped>
.document-list {
  max-width: 800px;
}
</style>
